var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditState(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#E5F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 29H29M21.7844 13.3117C21.7844 13.3117 21.7844 14.9463 23.419 16.581C25.0537 18.2156 26.6883 18.2156 26.6883 18.2156M15.3196 25.9881L18.7523 25.4977C19.2475 25.4269 19.7064 25.1975 20.06 24.8438L28.3229 16.581C29.2257 15.6782 29.2257 14.2145 28.3229 13.3117L26.6883 11.6771C25.7855 10.7743 24.3218 10.7743 23.419 11.6771L15.1562 19.94C14.8025 20.2936 14.5731 20.7525 14.5023 21.2477L14.0119 24.6804C13.903 25.4432 14.5568 26.097 15.3196 25.9881Z",
    stroke: "#0085FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditState);
export default __webpack_public_path__ + "static/media/edit-state.7bad733a7673f8c645a16aece10a9399.svg";
export { ForwardRef as ReactComponent };